import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { PersistConfig } from 'redux-persist'
import { storage } from '../core'
import { AuthState } from './auth.types'

const initialState: AuthState = {
  isAuthenticated: false,
  token: null,
  pendingQuery: null,
}

export const AUTH_STATE_NAME = 'auth'

export const authSlice = createSlice({
  name: AUTH_STATE_NAME,
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<{ token: string }>) => {
      state.isAuthenticated = true
      state.token = action.payload.token
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.token = null
      state.pendingQuery = null
    },
    setPendingQuery: (state, action: PayloadAction<string | null>) => {
      state.pendingQuery = action.payload
    },
  },
})

export const authSliceConfig: PersistConfig<AuthState> = {
  storage,
  key: AUTH_STATE_NAME,
  whitelist: ['isAuthenticated', 'token'],
}

export const { loginSuccess, logout, setPendingQuery } = authSlice.actions

export default authSlice.reducer
